import type { ZodError } from 'zod/v4';

export class InvalidRequestSchemaError extends Error {
  static readonly PREFIX = 'Invalid request schema:';

  constructor(details: ZodError) {
    super(`${InvalidRequestSchemaError.PREFIX} ${details}`);
    this.name = 'InvalidRequestSchema';
    Object.setPrototypeOf(this, InvalidRequestSchemaError.prototype);
  }
}
